<template>
  <div style="color:#fff" class="rightBar">
    <v-drawer :direction="'right'" :width="'26%'">
      <div class="animated fadeInRightBig" style="height:100%;width:100%;">
        <!--
        <bar-card class="lefts" :bg="'border2'">
          <v-title>产业分布</v-title>
          <div class="panelContent">
            <right-top />
          </div>
        </bar-card> -->
        <bar-card class="lefts lefts2 lefts4" :bg="'border2'">
          <v-title>茂名品种规模分析</v-title>
          <div class="panelContent">
            <right-mid />
          </div>
        </bar-card>
        <bar-card class="lefts lefts4" :bg="'border2'">
          <!-- <v-title>价格监测</v-title> -->
          <v-title>销区价格历年对比</v-title>
          <div class="panelContent">
            <left-mid />
          </div>
        </bar-card>
        <!-- <right-yz /> -->
        <bar-card class="lefts lefts3 lefts4" :bg="'border2'">
          <v-title>荔枝产地环境监测</v-title>
          <div class="panelContent">
            <right-bot />
          </div>
        </bar-card>
      </div>
    </v-drawer>
  </div>
</template>

<script>
// import rightCp from "../homeDrawer/rightBar/rightCp";
// import rightTop from "./rightBar/rightTop";
import rightMid from "./rightBar/rightMid";
import rightBot from "./rightBar/rightBot";
// import rightYz from "../homeDrawer/rightBar/rightYz";
import leftMid from "./leftBar/leftMid";
export default {
  components: {
    // rightTop,
    rightMid,
    rightBot,
    // rightYz
    leftMid
  },
  data() {
    return {};
  }
};
</script>

<style lang="stylus" scoped>
.panelContent
  height calc(100% - 43px)
  color #fff
.lefts
  // height calc(83.5% - 8px)
  height calc(30% - 8px)
  margin-bottom 8px
.lefts2
  height calc(26% - 8px)
.lefts3
  height calc(44% - 8px)
.lefts4
  height calc(33.3% - 8px)
@media (min-height 1400px)
  .rightBar
    >>>.side
      width 24% !important
</style>
